import { EVENT_TYPE, FORM_NAME } from '../../../../lib/analytics-constants';

export const LOCATION_ANALYTICS_CONFIG = {
  enabled: true,
  payload: {
    bedrock: {
      eventType: EVENT_TYPE.US_LOCATION_UPDATED,
      form_name: FORM_NAME.MRT_CALCULATOR_LATEST_RATES,
      was_prefilled: true,
      additional_attributes: {
        location_type: 'property_location',
      },
    },
  },
};

export const ANNUAL_INTEREST_RATE_ANALYTICS_CONFIG = {
  enabled: true,
  payload: {
    bedrock: {
      eventType: EVENT_TYPE.MORTGAGE_INTEREST_RATE_APR_UPDATED,
      was_prefilled: true,
      form_name: FORM_NAME.MRT_CALCULATOR_LATEST_RATES,
    },
  },
};

export const LOAN_TERM_ANALYTICS_CONFIG = {
  enabled: true,
  payload: {
    bedrock: {
      eventType: EVENT_TYPE.MORTGAGE_TERM_UPDATED,
      form_name: FORM_NAME.MRT_CALCULATOR_LATEST_RATES,
      was_prefilled: true,
    },
  },
};
